<tbody class="empty-tbody" *ngIf="totalItems === 0">
  <tr>
    <td style="width: 100%;"><span>&nbsp;</span></td>
  </tr>
  <tr>
    <td style="width: 100%;"><span>&nbsp;</span></td>
  </tr>
  <tr>
    <td style="width: 100%;"><span>&nbsp;</span><span class="empty-warning">{{ 'no-data' | translate }}</span></td>
  </tr>
  <tr>
    <td style="width: 100%;"><span>&nbsp;</span></td>
  </tr>
  <tr>
    <td style="width: 100%;"><span>&nbsp;</span></td>
  </tr>
</tbody>